import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';

// TODO(lenny) remove the date-serializing version of YearMonthDay
export const YearMonthDay = ProtoBaseModel.extend({
  year: attr(Number),
  monthOfYear: attr(Number),
  dayOfMonth: attr(Number)
}).reopenClass({
  fromMoment(moment) {
    // Proto month is 1-indexed, moment month is 0-indexed
    return this.create({
      year: moment.year(),
      monthOfYear: moment.month() + 1,
      dayOfMonth: moment.date()
    });
  }
});